import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

/////////////////// LAZY LOAD ////////////////////////////
import Loadable from 'react-loadable';
import Loading from './common_components/Loading';

const AsyncMain = Loadable({
  loader: () => import('./igbusiness_components/Main'),
  loading: Loading,
});
//////////////////////////////////////////////////////////

export default class IgBusiness extends React.Component {
  render() {
    return <BrowserRouter>
      <Route render={(p) => <AsyncMain {...p} {...this.props} />} />
    </BrowserRouter>
  }
}
